import { ModuleIOValueTypeEnum, ModuleInputKeyEnum, ModuleTemplateTypeEnum } from '../../constants';
import { FlowNodeInputTypeEnum, FlowNodeTypeEnum } from '../../node/constants';
import { FlowModuleTemplateType } from '../../types';
import { Input_Template_Switch } from '../input';
import { Output_Template_Finish } from '../output';

export const SetChatAttributesModule: FlowModuleTemplateType = {
  id: FlowNodeTypeEnum.setChatAttributes,
  templateType: ModuleTemplateTypeEnum.tools,
  isTool: true,
  flowType: FlowNodeTypeEnum.setChatAttributes,
  avatar: '/imgs/module/cfr.svg',
  name: '设置自定义属性节点',
  description: '设置该聊天客户的某个属性',
  inputs: [
    Input_Template_Switch,
    {
      key: ModuleInputKeyEnum.chatId,
      type: FlowNodeInputTypeEnum.hidden,
      label: 'chatId',
      valueType: ModuleIOValueTypeEnum.string,
      value: '{chatId}',
    },
    {
      key: 'addKv',
      type: FlowNodeInputTypeEnum.addKv,
      label: '',
      showTargetInApp: false,
      showTargetInPlugin: false,
    },
  ],
  outputs: [Output_Template_Finish],
};
